/* eslint-disable react/require-default-props */
import React from 'react';
import { connect } from 'react-redux';

import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';

import ReportTableContainer from 'reports/Common/ReportTable';
import { convertPaymentTypeDataToCashCardSplitClientTableData } from 'reports/utils';

class CashCardSplitClientTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const currencyAbbr = this.props.currency;
    return (
      <div id="cash-card-by-client">
        <ReportTableContainer
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          title="Cash/Card Split by client"
          data={{
            rows: convertPaymentTypeDataToCashCardSplitClientTableData(this.props.clients, currencyAbbr),
          }}
        />
        <br /> <br /> <br />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currency: selectCurrentSalonCurrency(state),
});

const CashCardSplitClientTableHoc = connect(mapStateToProps)(CashCardSplitClientTable);

export default CashCardSplitClientTableHoc;
